<span aria-hidden="true">
  <ng-content></ng-content>
</span>
